import React from "react";
import "./index.module.scss";

const Loading = ({ state = false }) => {
  if (!state) return false;
  return (
    <div className="m-2 text-center">
      <div className="spinner-border text-warning" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/views/lib/Loading/index.js